import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from '../../config/axios'
import { Feedback } from './types'

export const createFeedback = createAsyncThunk<Feedback, Feedback>(
  'feedback/createFeedback',
  async (feedbackData) => {
    try {
      const formData = new FormData()

      Object.entries(feedbackData).forEach(([key, value]) => {
        if (key === 'imageFile' && value instanceof File) {
          formData.append(key, value)
        } else if (value && typeof value === 'object') {
          formData.append(key, JSON.stringify(value))
        } else if (value !== undefined && value !== null) {
          formData.append(key, value)
        }
      })

      const response = await axios.post('/feedback/createFeedback', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      return response.data
    } catch (error: any) {
      console.error('Failed to send feedback:', error.response?.data || error.message)
      throw error // Forward error to thunk's error handling
    }
  },
)

export const fetchFeedbacks = createAsyncThunk<Feedback[]>(
  'feedback/getAllFeedbacks',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get<Feedback[]>('/feedback/getAllFeedbacks')
      return response.data
    } catch (error) {
      console.log(error)
      return rejectWithValue(error)
    }
  },
)
